import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import CommonForm from 'components/commonForm/CommonForm';
import { getLogin } from 'redux/actions/UserLogin';
import Otp from 'pages/otp/Otp'
import { loginForm } from 'pages/signup/formdata';
import login_hand from 'assets/images/login_hand.png';
import logo from 'assets/images/companyLogo.svg';

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searhParams] = useSearchParams()
  const userLogin = useSelector((state) => state);
  const isLoader = userLogin?.userLogin?.loading;
  const [onOtp, setOnOtp] = useState(false)

  const handleredirect = () => {
    navigate('/signup')
  }

  const onOtpPage = (val) => {
    setOnOtp(val)
  }
  useEffect(() => {
    setOnOtp(false);
  }, []);

  const onLogin = (data, code) => {
    const type = localStorage.getItem('type')
    localStorage.clear();
    localStorage.setItem('type', type)
      const loginPayload = {
      userDetails: {
        platform: 'CustomerApp',
        mobileOrEmail: data.mobile,
        countryCode: '+91',
      },
      actionType: "login"
    }
    dispatch(getLogin(loginPayload, navigate,setOnOtp));
  };
  useEffect(() => {
    if(userLogin?.userLogin?.userLogin?.success){
      setOnOtp(true)
    }else{
      setOnOtp(false)
    }
  }, [isLoader, userLogin]);

  return (
    <div>
      {onOtp === false &&<Box sm={{ flexGrow: 1 }} className=" mobileRes h100">
        <Grid container spacing={2} className='p10'>
          {/* ---login Part--- */}
          <Grid item sm={6}>
            {/* ---login nav--- */}
            <Box
              sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center' }}
            >
              <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="flex-start"
              >
                <Grid container item alignItems="center" >
                  <img src={logo} className="logoImg" alt="otplogo" />
                </Grid>
              </Grid>
            </Box>
            {/* ---login input type--- */}
            <div className="loginInput mobileBg">
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                rowSpacing={4}
              >
                <Grid item sm={10}className='textCenter'>
                  <img src={login_hand} alt="hand" />
                  <Typography className="fontBold font36 colorBlue">
                  Let's get <span className="colorYellow">started</span>
                  </Typography>
                  <Typography className="colorGrey fontInput fontNormal">
                    Enter your Login details below
                  </Typography>
                </Grid>
                <Grid item sm={7}>
                  <CommonForm
                    formData={loginForm}
                    button={'Login'}
                    onSubmittBtn={onLogin}
                    loading={isLoader}
                  />
                </Grid>
              </Grid>
              <Typography className="colorGrey font18 fontNormal marginTop">Don't have an account ?<span className="colorBlue cursor" onClick={handleredirect}>&nbsp;Signup now</span></Typography>
            </div>
          </Grid>
          {/* ---Image Part--- */}
          <Grid item sm={6} sx={{ display: { xs: 'none', sm: 'flex' }}} className="bgImage">
            <div className="loginBgImg"></div>
          </Grid>
        </Grid>
      </Box>}
      {onOtp&&<Otp onOtpPage={onOtpPage} setOnOtp={setOnOtp}/>}
    </div>
  );
}
